/* 布局 */
//前台
import Layout from "@views/layout";

const questionsubjectRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "questionsubject",
            name: "QUESTIONSUBJECT",
            meta: {
                title: "调查问卷题目",
                sort: 1,
            },
            component: () => import("@views/business/questionsubject/index.vue"),
            redirect: {
                name: "QUESTIONSUBJECT_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "QUESTIONSUBJECT_LIST",
                    meta: {
                        title: "调查问卷题目",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/questionsubject/list.vue"),
                },
                                {
                    path: "add",
                    name: "QUESTIONSUBJECT_ADD",
                    meta: {
                        title: "新增调查问卷题目",
                        parentPath: '/business/questionsubject/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionsubject/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "QUESTIONSUBJECT_EDIT",
                    meta: {
                        title: "编辑调查问卷题目",
                        parentPath: '/business/questionsubject/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionsubject/form.vue"),
                },
                                        ],
    },


        ],
};

export default questionsubjectRouter;
